// import React from 'react';
// import { useSelector } from 'react-redux';
// import CartProduct from "../component/CartProduct";
// import empty from "../asset/empty.gif";
// import toast from 'react-hot-toast';
// import { loadStripe } from "@stripe/stripe-js";
// import { useNavigate } from 'react-router';

// const Cart = () => {
//   const productCartItem = useSelector((state) => state.product.cartItem);
//   const user = useSelector((state) => state.user);
//   const navigate = useNavigate();

//   // Helper function to parse price safely
//   const parsePrice = (priceString) => {
//     if (typeof priceString === "number") return priceString; // Already a number
//     if (!priceString || typeof priceString !== "string") return 0; // Default to 0 for invalid values
//     return parseFloat(priceString.replace(/,/g, '')) || 0; // Remove commas, convert to float
//   };

//   // Calculate total price
//   const totalPrice = productCartItem.reduce((acc, curr) => {
//     const itemPrice = parsePrice(curr.price); // Parse individual price
//     const itemTotal = curr.total ? parsePrice(curr.total) : curr.qty * itemPrice; // Compute total if not present
//     return acc + itemTotal; // Accumulate totals
//   }, 0);

//   // Calculate total quantity
//   const totalQty = productCartItem.reduce((acc, curr) => {
//     const qty = curr.qty ? parseInt(curr.qty, 10) : 0; // Parse quantity
//     return acc + qty; // Accumulate quantities
//   }, 0);

//   // Handle payment process
//   const handlePayment = async () => {
//     if (user.email) {
//       try {
//         const stripePromise = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
//         const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/checkout-payment`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(
//             productCartItem.map((item) => ({
//               ...item,
//               price: parsePrice(item.price), // Ensure price is numeric
//               total: parsePrice(item.total), // Ensure total is numeric
//             }))
//           ),
//         });

//         if (!res.ok) {
//           console.error("Error during payment initialization:", await res.text());
//           toast.error("Server error during payment initialization.");
//           return;
//         }

//         const data = await res.json();
//         toast.success("Redirecting to payment gateway...");
//         stripePromise.redirectToCheckout({ sessionId: data });
//       } catch (error) {
//         console.error("Payment error:", error);
//         toast.error("Payment failed. Please try again.");
//       }
//     } else {
//       toast.error("You must be logged in to proceed with payment.");
//       setTimeout(() => navigate("/login"), 1000);
//     }
//   };

//   return (
//     <div className="p-2 md:p-4">
//       <h2 className="text-lg md:text-2xl font-bold text-slate-600">Your Cart Items</h2>
//       {productCartItem.length > 0 ? (
//         <div className="my-4 flex gap-3">
//           {/* Cart Items */}
//           <div className="w-full max-w-3xl">
//             {productCartItem.map((item) => (
//               <CartProduct
//                 key={item._id}
//                 id={item._id}
//                 name={item.name}
//                 image={item.image}
//                 category={item.category}
//                 qty={item.qty}
//                 total={parsePrice(item.total)} // Normalize total for display
//                 price={parsePrice(item.price)} // Normalize price for display
//               />
//             ))}
//           </div>

//           {/* Summary Section */}
//           <div className="w-full max-w-md ml-auto">
//             <h2 className="bg-blue-500 text-white p-2 text-lg">Summary</h2>
//             <div className="flex w-full py-2 text-lg border-b">
//               <p>Total Qty:</p>
//               <p className="ml-auto w-32 font-bold">{totalQty}</p>
//             </div>
//             <div className="flex w-full py-2 text-lg border-b">
//               <p>Total Price:</p>
//               <p className="ml-auto w-32 font-bold">
//                 <span className="text-red-500">₹</span>{totalPrice.toFixed(2)}
//               </p>
//             </div>
//             <button
//               className="bg-red-500 w-full text-lg font-bold py-2 text-white"
//               onClick={handlePayment}
//             >
//               Payment
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div className="flex w-full justify-center items-center flex-col">
//           <img src={empty} alt="Empty Cart" className="w-full max-w-sm" />
//           <p className="text-slate-500 text-3xl font-bold">Empty Cart</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Cart;



import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router';
import { loadStripe } from '@stripe/stripe-js';
import toast from 'react-hot-toast';

import CartProduct from '../component/CartProduct';
import empty from '../asset/empty.gif';

import { BsLightningChargeFill } from 'react-icons/bs';
import { RiSecurePaymentLine } from 'react-icons/ri';
import { HiArrowLeft, HiShoppingBag } from 'react-icons/hi';
import { SiStripe } from 'react-icons/si';

// ── Price parser ──────────────────────────────────────────────────────────────
const parsePrice = (val) => {
  if (typeof val === 'number') return val;
  if (!val || typeof val !== 'string') return 0;
  return parseFloat(val.replace(/,/g, '')) || 0;
};

// ── Empty state ───────────────────────────────────────────────────────────────
function EmptyCart() {
  return (
    <div className="flex flex-col items-center justify-center py-24 px-4 text-center">
      <div
        className="glass-card rounded-3xl p-12 flex flex-col items-center max-w-sm w-full animate-scale-up"
        style={{ border: '1px solid var(--glass-border)' }}
      >
        <img src={empty} alt="empty cart" className="w-36 mb-6 opacity-75 animate-float" />
        <h2 className="font-display text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
          EMPTY CART
        </h2>
        <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
          No items added yet. Start exploring our product catalogue.
        </p>
        <Link to="/">
          <button className="btn-primary flex items-center gap-2 px-7 py-3 rounded-xl text-xs">
            <HiShoppingBag />
            Browse Products
          </button>
        </Link>
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function Cart() {
  const cartItems = useSelector(s => s.product.cartItem);
  const user = useSelector(s => s.user);
  const navigate = useNavigate();

  const subtotal = cartItems.reduce((acc, cur) => {
    const lineTotal = cur.total
      ? parsePrice(cur.total)
      : cur.qty * parsePrice(cur.price);
    return acc + lineTotal;
  }, 0);

  const totalQty = cartItems.reduce((acc, cur) => acc + (parseInt(cur.qty) || 0), 0);
  const gst = subtotal * 0.18;
  const grandTotal = subtotal + gst;

  const handlePayment = async () => {
    if (!user.email) {
      toast.error('Please login to continue');
      setTimeout(() => navigate('/login'), 900);
      return;
    }
    if (grandTotal < 100) {
      toast.error('Minimum order value must be ₹100 to proceed with payment.');
      return;
    }
    try {
      const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/checkout-payment`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(cartItems),
      });
      if (!res.ok) throw new Error('Server error');
      const sessionId = await res.json();
      toast('Redirecting to Stripe…');
      stripe.redirectToCheckout({ sessionId });
    } catch (err) {
      toast.error('Payment failed — please try again.');
    }
  };

  return (
    <div
      className="min-h-screen py-10 px-4 md:px-6"
      style={{
        background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 60%, var(--bg-surface) 100%)',
      }}
    >
      <div className="max-w-5xl mx-auto">

        {/* Back + heading */}
        <div className="flex items-center gap-4 mb-8 animate-fade-up">
          <button
            onClick={() => navigate(-1)}
            className="glass rounded-xl p-2 border border-[var(--glass-border)]
                       hover:border-[var(--indigo)] transition-all duration-200"
          >
            <HiArrowLeft style={{ color: 'var(--text-muted)' }} />
          </button>
          <div>
            <p className="section-eyebrow mb-0.5">Review</p>
            <h1 className="font-display text-3xl font-bold" style={{ color: 'var(--text-primary)' }}>
              YOUR <span className="text-gradient">CART</span>
            </h1>
          </div>
        </div>

        {cartItems.length === 0 ? <EmptyCart /> : (
          <div className="flex flex-col lg:flex-row gap-6 items-start">

            {/* ── Items ──────────────────────────────────────────────────── */}
            <div className="flex-1 min-w-0 flex flex-col gap-3">
              {cartItems.map((el, i) => (
                <div key={el._id} style={{ animationDelay: `${i * 60}ms` }}>
                  <CartProduct
                    id={el._id}
                    name={el.name}
                    image={el.image}
                    category={el.category}
                    qty={el.qty}
                    total={el.total}
                    price={el.price}
                  />
                </div>
              ))}
            </div>

            {/* ── Order Summary ───────────────────────────────────────────── */}
            <div className="lg:w-80 w-full flex-shrink-0 sticky top-20">
              <div
                className="glass-hi rounded-2xl overflow-hidden animate-fade-up delay-200"
                style={{ border: '1px solid var(--glass-border-h)' }}
              >
                {/* Header */}
                <div
                  className="px-5 py-4"
                  style={{
                    background: 'linear-gradient(135deg, var(--indigo-dim), var(--cyan-dim))',
                    borderBottom: '1px solid var(--glass-border)',
                  }}
                >
                  <h2 className="font-display text-sm font-bold tracking-wider"
                    style={{ color: 'var(--text-primary)' }}>
                    ORDER SUMMARY
                  </h2>
                </div>

                {/* Rows */}
                <div className="px-5 py-4 space-y-0">
                  <div className="summary-row">
                    <span>Items ({totalQty})</span>
                    <strong>₹{subtotal.toFixed(2)}</strong>
                  </div>
                  <div className="summary-row">
                    <span>Shipping</span>
                    <strong style={{ color: 'var(--green)' }}>FREE</strong>
                  </div>
                  <div className="summary-row">
                    <span>GST (18%)</span>
                    <strong>₹{gst.toFixed(2)}</strong>
                  </div>
                </div>

                <div className="divider mx-5" />

                <div className="px-5 pt-3 pb-4 flex justify-between items-center">
                  <span className="font-display text-sm font-bold"
                    style={{ color: 'var(--text-primary)' }}>
                    GRAND TOTAL
                  </span>
                  <span className="font-display text-xl font-bold text-gradient">
                    ₹{grandTotal.toFixed(2)}
                  </span>
                </div>

                {/* CTA */}
                <div className="px-5 pb-5 flex flex-col gap-3">
                  <button
                    onClick={handlePayment}
                    className="btn-primary w-full py-3.5 rounded-xl flex items-center justify-center gap-2"
                  >
                    <BsLightningChargeFill />
                    Proceed to Pay
                  </button>
                  <div className="flex items-center justify-center gap-2">
                    <RiSecurePaymentLine style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }} />
                    <span className="text-xs font-mono" style={{ color: 'var(--text-muted)' }}>
                      Secured by
                    </span>
                    <SiStripe style={{ color: '#635bff', fontSize: '1.1rem' }} />
                  </div>
                </div>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
}
